import { removeConditionsTable } from "./remove_Conditions_Table_function";
import { resetPicturesForChanges } from "./reset_pictureInfo_for_changes";
import { createHealthInsExpense } from "../../../objects/AssetsExpenses/create_health_ins_expense";
import { createSalaryAsset } from "../../../objects/AssetsExpenses/create_salary_asset";
import createNotificationObj from "../../../objects/CommonUse/create_notification_obj";
import updateEventArr from "./update_event_arr";


export const activatePendingJob = (gameData, pictureInfo, eventTracker) => {
        let eventTrackerObj = {};
        if (eventTracker === true){
            eventTrackerObj = updateEventArr("PendingJob", gameData);
        }
        const pendingJob = gameData.pendingJob;
        // remove current salary asset and add asset for new salary 
        // amount adjusted for inflation
        gameData.assetTable = createSalaryAsset(gameData.assetTable, pendingJob.jobInfo.newMonthlySalary, 
            pendingJob.jobInfo.careerName, pendingJob.jobStartDate, gameData.startGameDate);
       
        // if health insurance indicator changes for new job, then create new health insurance exp item 
        // amount adjusted for inflation
        if (pendingJob.jobInfo.changeHealthIns === true){
            gameData.expenseTable = createHealthInsExpense(gameData.expenseTable, pendingJob.jobInfo.healthInsInd,
              pendingJob.jobStartDate, gameData.startGameDate)
        }
  
        // add new loan objects
        for (let i=0; i<pendingJob.loanTable.length; i++){
            gameData.loanTable.push(pendingJob.loanTable[i]);
        }
    
        // remove existing career conditions
        gameData.conditionsTable = removeConditionsTable(gameData.conditionsTable, pendingJob.class);

        // remove any outstanding 'college' conditions
        gameData.conditionsTable = removeConditionsTable(gameData.conditionsTable, "college");

        // add conditions for the new job
        for (let i=0; i<pendingJob.jobConditions.length; i++){
             gameData.conditionsTable.push(pendingJob.jobConditions[i]);
        }
        let additionalInfo = {careerName: pendingJob.jobInfo.careerName};
        const notificationObj = createNotificationObj("jobChange", additionalInfo);
        // update picture info
        //   let jobInfo={jobMaxSalary: jobMaxSalary, jobLevel3: level2Title, jobLevel3: level3Title};
        pictureInfo = resetPicturesForChanges("career", pictureInfo, pendingJob.pictureInfo.careerID,
            pendingJob.pictureInfo.careerName, pendingJob.pictureInfo.careerPictureImg,
            pendingJob.pictureInfo.careerBackgroundImg, {}, pendingJob.pictureInfo);
        gameData.jobInfo = {...pendingJob.jobInfo, jobStartDate: pendingJob.jobStartDate};
        const returnObj = {notificationObj: notificationObj, eventTrackerObj: eventTrackerObj,
            pictureInfo: pictureInfo
        }
                                      
    return returnObj;
   
}
export default activatePendingJob;





